import React from 'react'

const AlertModel = ({
    showModal,
    onClosedModal,
    clickOnSecondButton,
    secondButtonTitle = "OK",
    messages = ''
}) => {
    return (
        <>
            {showModal && (
                <div className="modal fade show d-block" tabIndex={-1} role="dialog" key={messages}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Alert</h5>

                                <span aria-hidden="true" className='fs-5  cursor_pointer ms-auto' onClick={() => onClosedModal()}>&times;</span>

                            </div>
                            <div className="modal-body">
                                {messages}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => onClosedModal()}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary"
                                    onClick={() => clickOnSecondButton(false)}
                                >{secondButtonTitle}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Overlay background (to close modal when clicking outside) */}
            {showModal && <div className="modal-backdrop fade show" onClick={() => onClosedModal(false)}></div>}
        </>
    )
}

export default AlertModel